import React from 'react';
import PaymentExportAllExportItem from '../../../../Domain/PaymentExportAllExportItem';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import PaymentExportAllExportService from '../../../../Services/PaymentExportAllExportService';
import PrintCheckItem from '../PrintCheckItem';
import PrintCheckWindowDescription from '../PrintCheckWindowDescription';
import PaymentExportAllExportSearchParams from './PaymentExportAllExportSearchParams';

export default class AllExportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      selected: -1,
      selectedItem: null,
      shownPanel: PaymentExportAllExportSearchParams.isThereAnySearchParameter()
        ? ShownPanelsEnum.Search
        : ShownPanelsEnum.None,
      searchItem: new PaymentExportAllExportSearchParams(),
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    this.refresh = this.refresh.bind(this);

    PaymentExportAllExportItem.clickOnPdf = this.clickOnPdf.bind(this);
  }

  clickOnPdf(selectedItem) {
    this.setState({
      selectedItem: selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    if (refresh) {
      this.refresh();
    }
  }

  renderPanels() {
    switch (this.state.shownPanel) {
      case ShownPanelsEnum.EditItem:
        let tempEdited = new PrintCheckItem({ exportId: this.state.selectedItem.XpId, firstCheck: 1 });
        return (
          <div>
            <GeneralEditWizzardBase
              crudType={CrudTypesEnum.Create}
              editedItem={tempEdited}
              clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
              clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
              windowDescription={PrintCheckWindowDescription}
              errorCode='AEA84'
            />
          </div>
        );
      default:
        break;
    }
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderPanels()}
        <TabOfDataTable
          type={PaymentExportAllExportItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={PaymentExportAllExportService.GetListBySearching}
          convertDBItemsFunction={PaymentExportAllExportService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          searchParamsType={PaymentExportAllExportSearchParams}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in export ID and YRMO...'
          errorCode='AEA115'
        />
      </div>
    );
  }
}
